module.exports = __webpack_public_path__ + "media/images/preview-fd7a8ff6d6c0e361f14f7f1544611012.png";